module.exports = __webpack_public_path__ + "img/facebook-brands.50f94548.svg";